module.exports = __webpack_public_path__ + "img/middleware.d9a22849.svg";